import styled from "styled-components";
import { Cores } from "../../styles/GlobalStyles";

export const HeroCss = styled.section`
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }
`;

export const HeroImage = styled.img`
  width: 100%;
  height: 100vh;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
`;

export const Text = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  color: ${Cores.secondary};
  padding: 0 20px;

  h1 {
    font-size: clamp(3rem, 6vw, 6rem);
    font-style: italic;
    margin-bottom: 8px;

    @media (max-width: 768px) {
      font-size: 3rem;
    }
  }

  p {
    font-size: clamp(1rem, 2vw, 1.5rem);
    margin-bottom: 16px;
    font-style: italic;
    letter-spacing: 0.2em;
    text-transform: uppercase;

    @media (max-width: 768px) {
      font-size: 1rem;
      letter-spacing: 0.15em;
    }
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  z-index: 2;
  margin-top: 8px;

  a {
    color: ${Cores.secondary};
    font-size: 2rem;
    transition: all 0.3s ease;
    padding: 8px;

    &:hover {
      color: ${Cores.primary};
      transform: translateY(-5px) scale(1.1);
    }
  }
`;

export const Title = styled.h1`
  font-size: 3.5rem;
  font-weight: 800;
  color: ${Cores.textDark};
  margin-bottom: 12px;
  line-height: 1.2;
  max-width: 800px;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const Subtitle = styled.p`
  font-size: 1.25rem;
  color: #666;
  margin-bottom: 32px;
  max-width: 600px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;
